import friendsUpdates from "../../apis/frdUpdates";
export default {
  createFriends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await friendsUpdates.createFriends(payload);
        // commit("CREATE_DOCTOR", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  getFriends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await friendsUpdates.getFriends(payload);

        commit("GET_FRIENDS_UPDATES", data.data);

        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  deleteFriends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await friendsUpdates.deleteFriends(payload);
        // commit("DELETE_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
  editFriends({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await friendsUpdates.editFriends(payload);
        // commit("EDIT_DOCTOR", data.data);
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },
};
